// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__24rZJ","disabled":"FileBtn_disabled__3UzP4","warn":"FileBtn_warn__24VbD","fade":"FileBtn_fade__2_ciu"};